import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import GuestRoute from "./components/GuestRoute";
import PrivateRoute from "./components/PrivateRoute";
import Home from "../scenes/Home/Home";
import Login from "../scenes/Login/Login";
import NotFound from "../scenes/NotFound/NotFound";
import TenantInfo from "../scenes/TenantInfo/TenantInfo";
import { ENV, MenuType } from "../config/Config";
import DynamicViewer from "../scenes/DynamicViewer/DynamicViewer";
import People from "../scenes/People/People";
import { User } from "../models/User";
import { useSelector } from "react-redux";

export default function AppRoutes() {
  let protectedFirstRoute = "/home";
  const user: User = useSelector((state: any) => state.auth);
  const menus = user.allowedMenus.filter((menu) => {
    return [
      MenuType.STANDARD_MENU as string,
      MenuType.IFRAME_VIEWER as string,
    ].includes(menu.menuTypeId);
  });

  if (menus.length > 0) {
    const firstMenu = menus[0];
    if (firstMenu.redirectLink) {
      if (firstMenu.menuTypeId === MenuType.STANDARD_MENU) {
        protectedFirstRoute = firstMenu.redirectLink;
      }
      if (firstMenu.menuTypeId === MenuType.IFRAME_VIEWER) {
        protectedFirstRoute = `/dynamic-viewer/${firstMenu.code}`;
      }
    }
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to={protectedFirstRoute} />} />
      <Route path="/login" element={<GuestRoute outlet={<Login />} />} />
      <Route path="/home" element={<PrivateRoute outlet={<Home />} />} />
      <Route
        path="/dynamic-viewer/:key"
        element={
          <PrivateRoute
            outlet={<DynamicViewer />}
            type={MenuType.IFRAME_VIEWER}
          />
        }
      />
      {ENV === "development" && (
        <Route path="/tenant-info" element={<TenantInfo />} />
      )}
      <Route path="/people" element={<PrivateRoute outlet={<People />} />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
